module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-3-caae2d3e76b42fb23d678bd7e23f322e.webp";